/**
 * @flow
 * @relayHash 38b49ad434470d5651700f1a45a13b0b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CronExecuteMutationVariables = {|
  functionUrl?: ?string,
  params?: ?any,
|};
export type CronExecuteMutationResponse = {|
  +executeCron: ?{|
    +response: ?string
  |}
|};
export type CronExecuteMutation = {|
  variables: CronExecuteMutationVariables,
  response: CronExecuteMutationResponse,
|};
*/


/*
mutation CronExecuteMutation(
  $functionUrl: String
  $params: GenericScalar
) {
  executeCron(functionUrl: $functionUrl, params: $params) {
    response
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "functionUrl",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "params",
    "type": "GenericScalar",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "executeCron",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "functionUrl",
        "variableName": "functionUrl"
      },
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "ExecuteCron",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "response",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CronExecuteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CronExecuteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CronExecuteMutation",
    "id": null,
    "text": "mutation CronExecuteMutation(\n  $functionUrl: String\n  $params: GenericScalar\n) {\n  executeCron(functionUrl: $functionUrl, params: $params) {\n    response\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5a30e4322a237dd308c920b0b9079715';
module.exports = node;
